/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { useContext } from 'react';
import DiviFieldCard from '../../../customs/DiviFieldCard/DiviFieldCard';
import { ReportsAPIContext } from '../../../../provider/ReportsAPIProvider';
import { defaultRecords } from '../../../../DefaultRecords';
import { NodeType } from '../../../../backendModels/report.model';
import DebouncedTextField from '../../../customs/debouncedTextField/DebouncedTextField';
import { CardId } from '../../../../models/diviCard';
import { useFreshCallback } from '../../../../utils/hooks';
import { PageType } from '../../../../models/diviPage';
import { SAMPLER_PLUS_S_RECORD_ELEMENT_KEY, SAMPLERPlusSRecord } from '../../../../models/genericElements/samplerPlusS';
import RecordInputInfo from '../../../customs/recordInputInfo/RecordInputInfo';
import { isGenericRecordDeletable } from '../../../../models/generic';

interface AnamneseProps {
  nodeType: NodeType;
}

export default function AnamneseNote({ nodeType }: AnamneseProps) {
  const { findRecordOrDefault, adaptRecord } = useContext(ReportsAPIContext);
  const record = findRecordOrDefault(defaultRecords.situationAndSymptoms.type, nodeType);
  const samplerPlusSRecord = findRecordOrDefault(
    'generic',
    nodeType,
    SAMPLER_PLUS_S_RECORD_ELEMENT_KEY
  ) as SAMPLERPlusSRecord;

  const note = record.note || '';

  const changeNote = useFreshCallback((value: string) => {
    adaptRecord(defaultRecords.situationAndSymptoms.type, nodeType, (draft, deleteRecord) => {
      if ((!draft.situationAndSymptoms || draft.situationAndSymptoms.length === 0) && value === '') {
        deleteRecord();
      } else if (value === '') {
        delete draft.note;
      } else {
        draft.note = value;
      }
    });
  });

  return (
    <DiviFieldCard cardType={CardId.AnamneseNote}>
      <DebouncedTextField
        className='no-margin-top'
        label={'Notfallgeschehen, Anamnese, Erstbefund, Vormedikation, Vorbehandlung'}
        placeholder={'Notfallgeschehen, Anamnese, Erstbefund, Vormedikation, Vorbehandlung'}
        multiline
        fullWidth
        rows={10}
        onDebounceChange={changeNote}
        value={note}
      />
      <RecordInputInfo
        className='add-margin-top'
        show={!isGenericRecordDeletable(samplerPlusSRecord)}
        page={PageType.SAMPLERPlusS}
      />
    </DiviFieldCard>
  );
}
